<template>
  <div id="app" @click="showDemoMenu = false">
    <div :class="['header', theme === 'dark' && 'light-dark']" v-if="!noHeaderUrl.includes(currentUrl)">
      <div class="header-l">
        <img :src="cfg.logo ? cfg.logo : require('./static/logo.png')" alt="/" class="logo" @click="handleGo('/index')" />
        <div class="nav">
          <div v-for="(item, index) in listNav" :key="index" :class="['item-nav', current == index && 'item-act']" :ref="item.url === '/device-demo' ? 'demoNav' : undefined" @click.stop="item.url === '/device-demo' ? toggleDemoMenu() : handleGo(item.url)">{{item.name}}</div>
        </div>
      </div>
      <div class="header-r" v-if="cfg.radio == 1">
        <div class="user-info" v-if="userInfo">
          <span>{{userInfo.nickname}}</span>
          <el-image style="width: 40px; height: 40px" :src="userInfo.headimgurl"></el-image>
        </div>
        <el-popover width="300" trigger="hover" style="margin-left: 10px;" v-else-if="!userInfo && isOurWeb">
          <wxlogin :appid="appid" scope="snsapi_login" :redirect_uri="redirect_uri"></wxlogin>
          <div class="weixin-info" slot="reference">
            <img src="./static/login.png" />
          </div>
        </el-popover>
        <div class="weixin-info" slot="reference" v-else>
          <img src="./static/login.png" @click="goLogin" />
        </div>
      </div>
    </div>
    <div v-if="showDemoMenu" class="demo-submenu" :style="demoMenuStyle" @click.stop>
      <button v-for="menu in demoMenus" :key="menu.name" :class="{'demo-submenu__active': activeDemoMenu === menu.name}" type="button" @click.stop="handleDemoMenu(menu)">{{menu.name}}</button>
    </div>
    <keep-alive include="apiIndex, sceneIndex">
      <router-view @onHeaderChange="onHeaderChange" @onHandleShow="onHandleShow" />
    </keep-alive>

    <card-moudle :cardShow="cardShow" :cardIndex="cardIndex" :cardData="cardData" />
    <cfg-moudle />
  </div>
</template>

<script>
// ?code=091YXZkl2IJCab4PvGkl254uZc1YXZkH&state=
import wxlogin from "vue-wxlogin";
import cardMoudle from "./components/card.vue"
import cfgMoudle from "./components/cfg.vue"
import { extractDomainOrIP, getUrlParams } from "@/utils/common"
import { creatSSE } from "@/utils/sse"
export default {
  name: 'App',
  components:{
    wxlogin,
    cardMoudle,
    cfgMoudle
  },
  data() {
    return {
      isOurWeb: false,
      userInfo: null,
      appid: 'wxfd03ade7e5d0299e',
      redirect_uri: encodeURIComponent("https://open.31gps.net/#/api"),
      theme: 'light',
      current: 0,
      lists: [
        {name: '首页', url: '/index'},
        {name: '接口文档', url: '/api'},
        // {name: '开发指南', url: '/develop'},
        {name: '设备扩展', url: '/device'},
        // {name: '更新日志', url: '/log'},
        {name: '代码开源', url: '/code'},
        {name: '视频讲座', url: '/video'},
        {name: '场景分析', url: '/scene'},
        {name: '三方工具', url: '/tool'},
        {name: '设备扩展-新版', url: '/device-demo'},
        // {name: '开发指南-新版', url: '/guide'},
        // {name: '配置', url: '/cfg'}
      ],
      // 不需要标题头部
      currentUrl: '/cfg',
      noHeaderUrl: ['/cfg', '/success'],
      cfg: {},
      cardShow: false,
      cardIndex: 0,
      cardData: {},
      showDemoMenu: false,
      demoMenuStyle: {},
      activeDemoMenu: '',
      demoMenus: [
        {name: '传感器数据'},
        {name: '部标 0X0200'},
        {name: '电池电量电压'},
        {name: '特殊指令'},
        {name: 'WIFI 基站'},
        {name: '激进驾驶扩展'},
        {name: '驾驶员信息'}
      ]
    }
  },
  computed: {
    listNav() {
      if(this.cfg.checkedLists) {
        const result = this.lists.map(item => {
          if(item.url === '/device-demo' || this.cfg.checkedLists.includes(item.url)) {
            return item
          }
        }).filter(item => !!item)
        return result
      } else {
        return this.lists
      }
    }
  },
  provide() {
    return {
      cfgData: () => this.cfg
    }
  },
  watch: {
    '$route': {
      handler(val) {
        const { path } = val
        this.currentUrl = path
        this.current = this.lists.findIndex(list => list.url === path)
        // 监听用户是否授权
        const code = this.getUrlCode(location.hash);
        if(code) {
          if(localStorage.getItem('userInfo')) {
            this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
          } else {
            this.getWeChatAuth(code)
          }
        }
      },
      deep: true
    }
  },
  mounted() {
    if(location.host === 'open.31gps.net') {
      this.isOurWeb = true
    }
    if(localStorage.getItem('userInfo')) {
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    }
    const params = getUrlParams(document.location.href)
    // if：地址栏参数带有url，则取该url的域名请求配置（不带协议、端口、路径）；else：根据referrer判断来源
    if(params.url) {
      this.getCfg(extractDomainOrIP(params.url) || location.hostname)
    } else {
      // if：用户通过其它页面打开的tab；else：用户直接在浏览器输入url
      const extractResult = extractDomainOrIP(document.referrer)
      if(extractResult) {
        let sessionId = params.sessionId || ''
        localStorage.setItem('sessionId', sessionId)
        localStorage.setItem('extractIp', extractResult)
        // if：用户已经重定向；else：用户没有重定向
        if(params.noHref == 1) {
          this.getCfg(location.hostname)
        } else {
          this.getCfg(extractResult, 'tab', sessionId, extractResult)
        }
      } else {
        this.getCfg(location.hostname)
        // this.getCfg('open.31gps.net')
      }
    }
    window.addEventListener('resize', this.updateDemoMenuPosition)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateDemoMenuPosition)
  },
  methods: {
    toggleDemoMenu() {
      this.showDemoMenu = !this.showDemoMenu
      if (this.showDemoMenu) {
        this.activeDemoMenu = ''
        this.$nextTick(this.updateDemoMenuPosition)
      }
    },
    updateDemoMenuPosition() {
      const nav = this.$refs.demoNav
      if (!nav) return
      const target = Array.isArray(nav) ? nav[0] : nav
      const rect = target.getBoundingClientRect()
      this.demoMenuStyle = {
        top: `${rect.top + 42}px`,
        left: `${rect.left + rect.width / 2}px`
      }
    },
    goLogin() {
      creatSSE(() => {
        window.open(`https://open.weixin.qq.com/connect/qrconnect?appid=wxfd03ade7e5d0299e&scope=snsapi_login&redirect_uri=https://open.31gps.net/canvas/success.html&state=0001&login_type=jssdk&self_redirect=default&style=black&href=./wx.css`, '_block')
      }, (e) => {
        try{
          this.userInfo = JSON.parse(e.data)
          localStorage.setItem('userInfo', e.data)
        } catch(e) {
          console.log(e)
        }
      })
    },
    onHeaderChange(val) {
      this.theme = val
    },
    handleGo(url) {
      this.showDemoMenu = false
      this.$router.push({
        path: url
      })
    },
    handleDemoMenu(menu) {
      this.showDemoMenu = false
      this.activeDemoMenu = menu.name
      this.$nextTick(() => this.$router.push({
        path: '/device-demo',
        query: { menu: menu.name }
      }))
    },
    onHandleShow(index, data) {
      setTimeout(() => {
        this.cardShow = true
        this.cardIndex = index
        this.cardData = data
      }, 300)
    },
    async getCfg(url, str, sessionId, ip) {
      const ret = await this.$Http('GET', { url }, '/api/apiCfg/getCfgByUrl');
      if(str === 'tab' && ret.url) {
        window.location.href = `http://${ret.url}#/index?sessionId=${sessionId}&ip=${ip}&noHref=1`
      } else {
        if(ret.exts) {
          this.cfg = JSON.parse(ret.exts)
          this.cfg.url = ret.url
        }
      }
      document.title = this.cfg.companyName || '三一平台.二次开发'
    },
    async getWeChatAuth(code) {
      const ret = await this.$Http('GET', { code }, '/api/apiDoc/getWxUserInfo');
      if(!ret.openid) {
        this.$message.warning("授权失败")
        localStorage.removeItem('userInfo')
      } else {
        const info = {
          headimgurl: ret.headimgurl,
          nickname: ret.nickname,
          openid: ret.openid
        }
        this.userInfo = info
        localStorage.setItem('userInfo', JSON.stringify(info))
      }
    },
    // 获取code
    getUrlCode(str) {
      if(str.indexOf('code=') == -1) return false;
      const s = str.indexOf('code=') + 5
      const e = str.indexOf('&state')
      return str.substring(s, e)
    }
  }
}
</script>

<style src="../assets/common.css"></style>
<style scoped>
ul{
  list-style: inherit;
}
</style>
<style scoped>
.header{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 90px;
  padding-left: 39px;
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  background: rgba(57, 57, 57, 0);
  transition: all 0.3s ease;
}
.header-l{
  display: flex;
  align-items: center;
}
.header-r{
  display: flex;
  align-items: center;
  height: 100%;
  padding-right: 20px;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
}
.user-info{
  display: flex;
  align-items: center;
}
.user-info span{
  white-space: nowrap;
  margin-right: 20px;
}
.weixin-info img{
  width: 40px;
}
.light-dark{
  background: rgba(57, 57, 57, 1);
}
.logo{
  width: 250px;
  height: 60px;
  cursor: pointer;
}
.nav{
  display: flex;
  align-items: center;
  font-size: 18px;
  color: #fff;
}
.item-nav{
  position: relative;
  white-space: nowrap;
  margin-left: 60px;
  cursor: pointer;
}
.item-nav:hover{
  color: #4289DA;
}
.demo-submenu{
  position: fixed;
  z-index: 10;
  width: 220px;
  padding: 12px;
  border: 2px solid transparent;
  transform: translateX(-50%);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.36);
  background:
    linear-gradient(92deg, rgba(17, 17, 29, 0.8) 0%, rgba(17, 17, 29, 0.52) 100%) padding-box,
    linear-gradient(264deg, rgba(30, 31, 51, 0.18), rgba(59, 77, 185, 1)) border-box;
  border-radius: 12px;
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
}
.demo-submenu::before{
  position: absolute;
  top: -7px;
  left: 50%;
  width: 12px;
  height: 12px;
  content: '';
  transform: translateX(-50%) rotate(45deg);
  background: rgba(9, 13, 35, 0.96);
  border-top: 1px solid rgba(83, 111, 212, 0.45);
  border-left: 1px solid rgba(83, 111, 212, 0.45);
}
.demo-submenu button{
  position: relative;
  z-index: 1;
  display: block;
  width: 100%;
  padding: 10px 14px;
  border: 0;
  border-radius: 30px;
  text-align: left;
  color: #a5dcff;
  background: transparent;
  cursor: pointer;
  font-size: 15px;
  margin-bottom: 10px;
}
.demo-submenu button:hover,
.demo-submenu button.demo-submenu__active{
  color: #fff;
  background: linear-gradient(0deg, #209CFF 0%, #68E0CF 100%);
  box-shadow: 0 4px 12px rgba(28, 137, 245, 0.35);
}
.item-act{
  color: #4289DA;
  font-weight: bold;
}
</style>
